// HeaderProfile.jsx
import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

function HeaderProfile({ settings }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuId = "menu-appbar";

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'left',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: 'white',
            color: 'black',
            transition: '1.5s'
          }
        }}
        onClick={handleMenu}
      >
        <IconButton
          edge="end"
          aria-label="account of current user"
          aria-controls={menuId}
          aria-haspopup="true"
          color="inherit"
          sx={{ marginRight: 1 }}
        >
          <AccountCircleIcon fontSize="large" />
        </IconButton>
        <Typography variant="subtitle1">鬼沢龍平</Typography>
      </Box>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            width: anchorEl ? anchorEl.clientWidth : undefined, 
          },
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {settings.map((setting) => (
          <MenuItem key={setting.name} onClick={() => { handleClose(); setting.action(); }}>
            <ListItemIcon>
              {setting.icon}
            </ListItemIcon>
            <ListItemText>{setting.name}</ListItemText> {/* Use ListItemText for text */}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default HeaderProfile;
